import React from "react";
import theme from "../../../styles/theme";

// Composant IconButton générique
const IconButton = ({ src, alt, onClick, disabled = false, style = {} }) => {
  return (
    <button
      style={{
        backgroundColor: disabled ? theme.buttons.disabled.background : "transparent",
        border: "none",
        borderRadius: theme.borders.radius.full,
        padding: theme.spacing.sm,
        cursor: disabled ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 0.2s ease",
        ...style,
      }}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.backgroundColor = theme.colors.background.muted;
      }}
      onMouseLeave={(e) => {
        if (!disabled) e.currentTarget.style.backgroundColor = "transparent";
      }}
      onMouseDown={(e) => {
        if (!disabled) e.currentTarget.style.backgroundColor = theme.colors.background.app;
      }}
      onMouseUp={(e) => {
        if (!disabled) e.currentTarget.style.backgroundColor = theme.colors.background.muted;
      }}
    >
      {src && <img src={src} alt={alt} style={{ width: "20px", height: "20px" }} />}
    </button>
  );
};


// Export des boutons prédéfinis
export const SaveIconButton = (props) => (
  <IconButton src="/assets/icones/save.svg" alt="Save" {...props} />
);

export const DeleteIconButton = (props) => (
  <IconButton src="/assets/icones/delete.svg" alt="Delete" {...props} />
);

export const EditIconButton = (props) => (
  <IconButton src="/assets/icones/edit.svg" alt="Edit" {...props} />
);

export const CancelIconButton = (props) => (
  <IconButton src="/assets/icones/cancel.svg" alt="Cancel" {...props} />
);

export const AddIconButton = (props) => (
  <IconButton src="/assets/icones/add.svg" alt="Add" {...props} />
);

export const RefreshIconButton = (props) => (
  <IconButton src="/assets/icones/refresh.svg" alt="Refresh" {...props} />
);

export const ArrowUpIconButton = (props) => (
  <IconButton src="/assets/icones/arrow-up.svg" alt="Settings" {...props} />
);
export const ArrowDownIconButton = (props) => (
  <IconButton src="/assets/icones/arrow-down.svg" alt="Settings" {...props} />
);

export const InfoIconButton = (props) => (
  <IconButton src="/assets/icones/info.svg" alt="Info" {...props} />
);
